export enum GrowthbookFlagsEnum {
  WhiteLabel = 'WhiteLabel',
  DSPhysicalProduct = 'DSPhysicalProduct',
  WorkflowSharing = 'WorkflowSharing',
  'AI-assistant' = 'AI-assistant',
  XmlImport = 'XmlImport',
  McpKeys = 'McpKeys',
  MaintenanceWork = 'MaintenanceWork',
  AiChat = 'AiChat',
  WebsiteShare = 'WebsiteShare',
  SquarePaymentIntegration = 'SquarePaymentIntegration',
  Helpdesk = 'Helpdesk',
  CommunityStats = 'CommunityStats',
  WhiteLabelRazorpay = 'WhiteLabelRazorpay',
  SubscriptionInvoices = 'SubscriptionInvoices',
  MigrateCustomLoginPage = 'MigrateCustomLoginPage',
}

export type FlagsPropsType = {
  flags: {
    [key in GrowthbookFlagsEnum]: boolean
  }
}
